import classNames from 'classnames/bind';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

const SelectSeatOption = ({
  personType,
  title,
  value,
  limitText,
  max,
  min,
  onSelect,
}: {
  personType: string;
  title: string;
  value: number;
  max: number;
  min: number;
  limitText: string;
  onSelect: (personType: string, diff: number, valid: boolean) => void;
}) => (
  <div
    className={cx('option', 'as_passenger')}
    role="spinbutton"
    aria-valuemin={min}
    aria-valuemax={max}
    aria-valuenow={value}
    aria-checked={value > 0}
  >
    <span className={cx('current')}>
      <b className={cx('value')}>
        {title} {value}명
      </b>
      <i className={cx('limit')}>{limitText}</i>
    </span>
    <button
      type="button"
      className={cx('inner')}
      aria-disabled={value <= min}
      aria-label="-"
      onClick={() => onSelect(personType, -1, value > min)}
    />
    <button
      type="button"
      className={cx('outer')}
      aria-disabled={value >= max}
      aria-label="+"
      onClick={() => onSelect(personType, 1, value < max)}
    />
  </div>
);

export default SelectSeatOption;
